import React, { useEffect, useState, useRef } from 'react';
import { Globe, Check, ChevronDown } from 'lucide-react';
import { useLanguage } from './TranslationProvider';
// Selector de idioma accesible:
// - Nombre del idioma en su propio idioma (no solo banderas)
// - Navegable por teclado, con atributos ARIA
// - Indicador del idioma activo
// - Buen contraste, responsive
export function LanguageSelector({
  variant = 'dark'
}: {
  variant?: 'dark' | 'light';
}) {
  const {
    lang,
    setLang,
    languages
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const active = languages.find(l => l.code === lang) || languages[0];
  // Cerrar al hacer clic afuera o presionar Escape
  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  const triggerClasses = variant === 'dark' ? 'text-white hover:text-sylmar-light' : 'text-charcoal hover:text-sylmar';
  return <div ref={containerRef} className="relative notranslate" data-id="element-110">
      <button type="button" onClick={() => setOpen(o => !o)} aria-haspopup="listbox" aria-expanded={open} aria-label={`Idioma actual: ${active.nativeName}. Cambiar idioma`} className={`flex items-center gap-1.5 font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sylmar focus-visible:ring-offset-1 rounded ${triggerClasses}`} data-id="element-111">
        <Globe className="w-4 h-4" aria-hidden="true" data-id="element-112" />
        <span data-id="element-113">{active.nativeName}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-114" />
      </button>

      {open && <ul role="listbox" aria-label="Seleccionar idioma" className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-2xl border border-gray-100 py-1.5 z-[10000] max-h-80 overflow-auto" data-id="element-115">
          {languages.map(option => {
        const isActive = option.code === lang;
        return <li key={option.code} role="none" data-id="element-116">
                <button type="button" role="option" aria-selected={isActive} lang={option.code} onClick={() => {
            setLang(option.code);
            setOpen(false);
          }} className={`w-full flex items-center justify-between gap-2 px-4 py-2.5 text-sm text-left transition-colors focus:outline-none focus-visible:bg-sylmar-light ${isActive ? 'bg-sylmar-light text-sylmar font-bold' : 'text-charcoal hover:bg-gray-50 font-medium'}`} data-id="element-117">
                  <span data-id="element-118">{option.nativeName}</span>
                  {isActive && <Check className="w-4 h-4 text-sylmar flex-shrink-0" aria-hidden="true" data-id="element-119" />}
                </button>
              </li>;
      })}
        </ul>}
    </div>;
}